<div class="side-drawer">
  <div *ngFor="let item of sidebardata" class="side-bar-item" (click)="handleTabs(item.title)" [ngStyle]="{'background':selectedTab === item.title ? '#aa8f9c':'','color':selectedTab !== item.title ? '#aa8f9c':''}">
     <img [src]="item.icon">
     <span style="font-size: 12px;">{{item.title}}</span>
  </div>
</div>
<div class="main" *ngIf="selectedTab === 'Overview Dashboard'">
    <div *ngIf="showLoader" class="loader">
      <div class="load">
        <mat-spinner></mat-spinner>
      </div>
    </div>
   <div *ngIf="true">
    <div class="actions">
      <div class="orderBox">
        <mat-form-field>
          <mat-label>{{'OVERVIEW_DASHBOARD.views' | translate}}</mat-label>
          <mat-select multiple [(ngModel)]="checkValues" >
            <mat-option *ngFor="let view of views;let i = index" (onSelectionChange)="updateView($event, i)" [value]="view.id">{{view.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="refresh">
        <mat-icon class="" (click)="openReorderModal()">reorder</mat-icon>
        <mat-icon class="" (click)="refresh()">refresh</mat-icon>
      </div>
    </div>

    <div class="scrollView">
      <div class="warning" *ngIf="this.show_warning">
        {{'OVERVIEW_DASHBOARD.warning_message' | translate}}
      </div>
        <div class="view"  *ngFor="let view of views;let i = index">
            <div class="liveStatus"  *ngIf="view.id == 'liveStatus' && view.show" @fadeIn>
                <div class="label">
                    {{'OVERVIEW_DASHBOARD.deadline_status' | translate}}
                    <div class="minimize">
                    <mat-icon aria-hidden="false" (click)="getDeadlineStatus()">refresh</mat-icon>
                    </div>
                </div>
                <div class="time">
                    {{'OVERVIEW_DASHBOARD.expiring_in' | translate}} {{ stats_settings.deadline_expiry.count }} {{ stats_settings.deadline_expiry.type }}
                </div>
                <div class="row">

                    <div class="card" (click)="openModal(0, deadline_status.acceptance.value);">
                    <div class="label">
                        {{'OVERVIEW_DASHBOARD.to_be_accepted' | translate}}
                        <mat-icon class="openNewDashIcon" (click)="openDashboard($event, 'live', 'acceptance')">launch</mat-icon>
                    </div>
                    <div class="content">
                        <mat-spinner *ngIf="deadline_status.acceptance.loader" [diameter]="20"></mat-spinner>
                        <span *ngIf="!deadline_status.acceptance.loader">{{ deadline_status.acceptance.value }}</span>
                    </div>
                    </div>
                    <div class="card" (click)="openModal(1, deadline_status.assignment.value);">
                    <div class="label">
                        {{'OVERVIEW_DASHBOARD.to_be_assigned' | translate}}
                        <mat-icon class="openNewDashIcon" (click)="openDashboard($event, 'live', 'assignment')">launch</mat-icon>
                    </div>
                    <div class="content">
                        <mat-spinner *ngIf="deadline_status.assignment.loader" [diameter]="20"></mat-spinner>
                        <span *ngIf="!deadline_status.assignment.loader">{{ deadline_status.assignment.value }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="overview"  *ngIf="view.id == 'overview' && view.show" @fadeIn>
                <div class="label">
                  {{'OVERVIEW_DASHBOARD.preshipment_status' | translate}}
                  <div class="minimize">
                    <mat-icon aria-hidden="false" (click)="getPreShipmentStatus()">refresh</mat-icon>
                    <!-- <div class="time">2 mins ago</div> -->
                  </div>
                </div>
                <div class="time">{{'OVERVIEW_DASHBOARD.next' | translate}} {{ stats_settings.shipment_pending.count }} {{stats_settings.shipment_pending.type}}</div>
                <div class="row">
                  <div class="card" (click)="openPreShipmentModal(0, preShipment_pending_data.acceptance.value);">
                    <div class="label">{{'OVERVIEW_DASHBOARD.pending_acceptance' | translate}}
                      <mat-icon class="openNewDashIcon" (click)="openDashboard($event, 'pre-shipment','acceptance')">launch</mat-icon>
                    </div>
                    <div class="content">
                      <mat-spinner *ngIf="preShipment_pending_data.acceptance.loader" [diameter]="20"></mat-spinner>
                      <span *ngIf="!preShipment_pending_data.acceptance.loader">{{ preShipment_pending_data.acceptance.value }}</span>
                    </div>
                  </div>
        
                  <div class="card" (click)="openPreShipmentModal(1, preShipment_pending_data.assignment.value);">
                    <div class="label">{{'OVERVIEW_DASHBOARD.pending_assignment' | translate}}
                      <mat-icon class="openNewDashIcon" (click)="openDashboard($event, 'pre-shipment','assignment')">launch</mat-icon>
                    </div>
                    <div class="content">
                      <mat-spinner *ngIf="preShipment_pending_data.assignment.loader" [diameter]="20"></mat-spinner>
                      <span *ngIf="!preShipment_pending_data.assignment.loader">{{ preShipment_pending_data.assignment.value }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="acceptanceStatus"  *ngIf="view.id == 'acceptance' && view.show" @fadeIn>
                <div class="label">
                    {{'OVERVIEW_DASHBOARD.acceptance_status' | translate}}
                    <div class="minimize">
                    <mat-icon aria-hidden="false" (click)="getAcceptanceStatus()">refresh</mat-icon>
                    </div>
                </div>
                <div class="time">
                    {{'OVERVIEW_DASHBOARD.last' | translate}} {{ stats_settings.shipment_acceptance.count }} {{ stats_settings.shipment_acceptance.type }}
                </div>
                <div class="row">
                  <div class="g-card" *ngIf="show_sim_tracker" (click)="openPreShipmentModal(2, '')">
                    <div class="content" *ngIf="!sim_tracking_consent_data.error_message">                        
                      <mat-spinner style="margin-left: auto;margin-right: auto; margin-top: 135px;" *ngIf="sim_tracking_consent_data.loader" [diameter]="25">
                      </mat-spinner>
                      <div echarts [options]="simTrackingConsentStatus" (chartClick)="consentPieChartClicked($event)" class="demo-chart" style="width: 60%; float: left;" *ngIf="!sim_tracking_consent_data.loader"></div>
                      <div class="tracking-details" *ngIf="!sim_tracking_consent_data.loader">
                        <div>
                            <mat-icon class="redirect-icon" (click)="openShipmentDashboard($event, 'consent')">launch</mat-icon>
                        </div>
                         <div class="tracking">
                          {{'OVERVIEW_DASHBOARD.consent_available' | translate}}
                         </div>
                         <div class="details" style="margin-top: 30px;">
                           <div class="right" >{{ sim_tracking_consent_available }}/{{ sim_tracking_consent_data.total_sum }}</div>
                          <mat-progress-bar mode="determinate" value="{{sim_tracking_progress_bar.consent_available}}" class="green-progress" style="height: 15px;"></mat-progress-bar>
                         </div>
                         <div class="tracking" style="margin-top:30px">
                            {{'OVERVIEW_DASHBOARD.consent_unavailable' | translate}}
                          </div>
                         <div class="details" style="margin-top: 30px;">
                          <div class="right" >{{ sim_tracking_consent_unavailable }}/{{ sim_tracking_consent_data.total_sum }}</div>
                         <mat-progress-bar mode="determinate" value="{{ sim_tracking_progress_bar.consent_unavailable }}" class="red-progress" style="height: 15px;"></mat-progress-bar>
                        </div>
                      </div>
                    </div>
                    <div class="error-message" *ngIf="sim_tracking_consent_data.error_message">
                      <h4>{{'OVERVIEW_DASHBOARD.sim_tracking_status' | translate}}</h4>
                      <span >
                        {{sim_tracking_consent_data.error_message}}
                      </span>
                    </div>
                  </div>
                  <div class="g-card" (click)="openPreShipmentModal(3, '')">
                    <div class="content" *ngIf="!driver_acceptance_status_data.error_message">
                      <mat-spinner style="margin-left: auto;margin-right: auto; margin-top: 135px;" *ngIf="driver_acceptance_status_data.loader" [diameter]="25">
                      </mat-spinner>
                      <div echarts [options]="driverAcceptanceStatus" class="demo-chart" (chartClick)="acceptancePieChartClicked($event)" style="width: 60%; float: left;" *ngIf="!driver_acceptance_status_data.loader"></div>
                      <div class="tracking-details" *ngIf="!driver_acceptance_status_data.loader">
                        <div>
                            <mat-icon class="redirect-icon" (click)="openShipmentDashboard($event, 'acceptance')">launch</mat-icon>
                        </div>
                         <div class="tracking">
                          {{'OVERVIEW_DASHBOARD.driver_accepted' | translate}}
                         </div>
                         <div class="details" style="margin-top: 30px;">
                           <div class="right" >{{ driver_acceptance_status_accepted }}/{{ driver_acceptance_status_data.total }}</div>
                          <mat-progress-bar mode="determinate" value="{{ driver_acceptance_progress_bar.driver_accepted }}" class="green-progress" style="height: 15px;"></mat-progress-bar>
                         </div>
                         <div class="tracking" style="margin-top:30px">
                            {{'OVERVIEW_DASHBOARD.driver_yet_to_accept' | translate}}
                          </div>
                         <div class="details" style="margin-top: 30px;">
                          <div class="right" >{{ driver_acceptance_status_yet_to_accept }}/{{ driver_acceptance_status_data.total }}</div>
                         <mat-progress-bar mode="determinate" value="{{ driver_acceptance_progress_bar.driver_yet_to_accept }}" class="red-progress" style="height: 15px;"></mat-progress-bar>
                        </div>
                      </div>
                    </div>
                    <div class="error-message" *ngIf="driver_acceptance_status_data.error_message">
                      <h4>{{'OVERVIEW_DASHBOARD.driver_acceptance_status' | translate}}</h4>
                      <span >
                        {{driver_acceptance_status_data.error_message}}
                      </span>
                    </div>
                  </div>
                </div>
            </div>
            
              <div class="statusCharts"  *ngIf="view.id == 'statusCharts' && view.show" @fadeIn>
                <div class="label">
                  {{'OVERVIEW_DASHBOARD.in_transit_shipment_status' | translate}}
                  <div class="minimize">
                    <mat-icon aria-hidden="false" (click)="resetInTransitGraphs();drawInTransitGraphs()">refresh</mat-icon>
                    <!-- <div class="time">2 mins ago</div> -->
                  </div>
                </div>
                <div class="time">{{'OVERVIEW_DASHBOARD.last' | translate}} {{ stats_settings.ongoing_shipment.count }} {{ stats_settings.ongoing_shipment.type }}</div>
                <div class="row">
                  <div class="card">
                    <!-- <div class="label">Dispatched Shipments Variation Graph</div> -->
                    <div class="content" *ngIf="!tracking_status_data.error_message">
                      <mat-spinner style="margin-left: auto;margin-right: auto; margin-top: 135px;" *ngIf="tracking_status_data.loader" [diameter]="25">
                      </mat-spinner>
                      <div echarts [options]="trackingStatusOption" class="demo-chart" style="width: 60%; float: left;" *ngIf="!tracking_status_data.loader"></div>
                      <div class="tracking-details" *ngIf="!tracking_status_data.loader">
                         <div>
                            <mat-icon class="redirect-icon" (click)="openShipmentDashboard($event, 'trackable')">launch</mat-icon>
                         </div>
                         <div class="tracking">
                          {{'OVERVIEW_DASHBOARD.trackable' | translate}} : {{ trackable_no }}
                         </div>
                         <div class="details" style="margin-top: 30px;">
                           <div class="left">{{'OVERVIEW_DASHBOARD.app_based' | translate}}</div>
                           <div class="right" >{{ tracking_status_data.trackable_app }}/{{ trackable_no }}</div>
                          <mat-progress-bar mode="determinate" value="{{ progress_bar.app }}" class="purple-progress" style="height: 15px;"></mat-progress-bar>
                         </div>
                         <div class="details" *ngIf="show_sim_tracker">
                          <div class="left">{{'OVERVIEW_DASHBOARD.sim_based' | translate}}</div>
                          <div class="right" >{{ tracking_status_data.trackable_sim }}/{{ trackable_no }}</div>
                         <mat-progress-bar mode="determinate" value="{{ progress_bar.sim }}" class="green-progress" style="height: 15px;"></mat-progress-bar>
                        </div>
                        <div class="details">
                          <div class="left">{{'OVERVIEW_DASHBOARD.gps_based' | translate}}</div>
                          <div class="right" >{{ tracking_status_data.trackable_gps }}/{{ trackable_no }}</div>
                         <mat-progress-bar mode="determinate" class="yellow-progress" value="{{ progress_bar.gps }}" style="height: 15px;"></mat-progress-bar>
                        </div>
                        <div class="tracking" style="margin-top:30px">
                          {{'OVERVIEW_DASHBOARD.non_trackable' | translate}} : {{ non_trackable_no }}
                        </div>
                      </div>
                    </div>
                    <div class="error-message" *ngIf="tracking_status_data.error_message">
                      <h4>{{'OVERVIEW_DASHBOARD.tracking_status' | translate}}</h4>
                      <span >
                        {{tracking_status_data.error_message}}
                      </span>
                    </div>
                  </div>
                  <div class="card">
                    <div class="content" *ngIf="!live_late_shipments_data.error_message">
                      <mat-spinner style="margin-left: auto;margin-right: auto; margin-top: 135px;" *ngIf="live_late_shipments_data.loader" [diameter]="25"></mat-spinner>
                      <div echarts [options]="liveLateShipmentsOption" class="demo-chart"  *ngIf="!live_late_shipments_data.loader"></div>
                    </div>
                    <div class="error-message" *ngIf="live_late_shipments_data.error_message">
                      <h4>{{'OVERVIEW_DASHBOARD.live_late_shipments' | translate}}</h4>
                      <span >
                        {{live_late_shipments_data.error_message}}
                      </span>
                    </div>
                  </div>

                  <!-- <div class="e-waybill-status">
                    <mat-spinner style="margin-left: auto;margin-right: auto; margin-top: 205px;"  *ngIf="waybill_expiry_data.loader" [diameter]="25"></mat-spinner>
                    <div *ngIf="!waybill_expiry_data.loader && !waybill_expiry_data.error_message">
                        <div class="header">
                            <div class="label">
                                {{'OVERVIEW_DASHBOARD.waybill_expiry_title' | translate}}
                              </div>
                              <div class="toggle-button">
                                <mat-button-toggle-group  #group="matButtonToggleGroup" value="today">
                                    <mat-button-toggle value="today">
                                        {{'OVERVIEW_DASHBOARD.today' | translate}}
                                    </mat-button-toggle>
                                    <mat-button-toggle value="tomorrow">
                                        {{'OVERVIEW_DASHBOARD.tomorrow' | translate}}
                                    </mat-button-toggle>
                                  </mat-button-toggle-group>
                              </div>
                        </div>
                        <div class="content">
                        <div class="table">
                          <table mat-table *ngIf="waybill_expiry_data.data.length;else noLocations" [dataSource]="waybill_expiry_data.data">
                            <ng-container matColumnDef="shipment_id">
                              <th mat-header-cell *matHeaderCellDef class="customHeader">
                                <span>
                                  {{'OVERVIEW_DASHBOARD.shipment_id' | translate}}
                                </span>
                              </th>
                              <td mat-cell *matCellDef="let element; let i = index">
                               <div>
                                {{element.shipment_id}}
                               </div>
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="date_time">
                              <th mat-header-cell *matHeaderCellDef class="customHeader">
                                  <span>
                                    {{'OVERVIEW_DASHBOARD.date_time' | translate}}
                                  </span>
                              </th>
                              <td mat-cell *matCellDef="let element" style="text-align: center;">
                                <span >
                                  {{element.date_time}}
                                </span>
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef class="customHeader">
                                </th>
                                <td mat-cell *matCellDef="let element" style="text-align: center;">
                                  <span>
                                    <div class="button">
                                        {{'OVERVIEW_DASHBOARD.extend' | translate}}
                                    </div>
                                  </span>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="waybill_displayedColumns;sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: waybill_displayedColumns;"></tr>
                          </table>
                        </div>
                        <ng-template #noLocations>
                          <div class="noLocations">
                            {{'OVERVIEW_DASHBOARD.no_info' | translate}}
                          </div>
                        </ng-template>
                      </div>
                    </div>
                    <div class="error-message"  style="margin-top: 180px;" *ngIf="waybill_expiry_data.error_message">
                      <h3>{{'OVERVIEW_DASHBOARD.waybill_expiry_title' | translate}}</h3>
                      <span>
                        {{ waybill_expiry_data.error_message }}
                      </span>
                    </div>
                  </div> -->

                  <div class="g-card">
                    <div class="content" *ngIf="!dispatched_shipments_graph.error_message">
                      <mat-spinner style="margin-left: auto;margin-right: auto; margin-top: 135px;"  *ngIf="dispatched_shipments_graph.loader" [diameter]="25"></mat-spinner>
                      <div echarts [options]="dispatchedShipmentsOption" class="demo-chart" *ngIf="!dispatched_shipments_graph.loader"></div>
                    </div>
                    <div class="error-message" *ngIf="dispatched_shipments_graph.error_message">
                      <h3>{{'OVERVIEW_DASHBOARD.ongoing_variation_graph' | translate}}</h3>
                      <span >
                        {{dispatched_shipments_graph.error_message}}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="variationGraphs"  *ngIf="view.id == 'variationGraphs' && view.show" @fadeIn>
                <div class="label">
                  {{'OVERVIEW_DASHBOARD.post_shipment_status' | translate}}
                  <div class="minimize">
                    <mat-icon aria-hidden="false" (click)="resetPostShipmentGraphs();drawPostShipmentGraphs()">refresh</mat-icon>
                    <!-- <div class="time">2 mins ago</div> -->
                  </div>
                </div>
                <div class="row">
                    <div class="card" (click)="openPostShipmentModal(1, '');">
                        <div class="label" *ngIf="!outstanding_epods_data.error_message">
                            {{'OVERVIEW_DASHBOARD.outstanding_epods' | translate}}
                        </div>
                        <div class="sub-label">{{'OVERVIEW_DASHBOARD.last' | translate}} {{ stats_settings.outstanding_epods.count }} {{stats_settings.outstanding_epods.type}} </div>

                        <div class="content" *ngIf="!outstanding_epods_data.error_message">
                            <mat-spinner style="margin-left: auto;margin-right: auto; margin-top: 30px;"  *ngIf="outstanding_epods_data.loader" [diameter]="25"></mat-spinner>
                            <div class="outstanding-epod-value"  *ngIf="!outstanding_epods_data.loader">
                                {{ outstanding_epods_data.value }}
                            </div>
                        </div>
                    
                        <div class="error-message" *ngIf="outstanding_epods_data.error_message">
                            <h3>{{'OVERVIEW_DASHBOARD.outstanding_epods' | translate}}</h3>
                            <span >
                            {{ outstanding_epods_data.error_message }}
                            </span>
                        </div>
                    </div>
                    <div class="g-card">
                        <div class="content" *ngIf="!fulfilled_shipments_graph.error_message">
                        <mat-spinner style="margin-left: auto;margin-right: auto; margin-top: 150px;"  *ngIf="fulfilled_shipments_graph.loader" [diameter]="25"></mat-spinner>
                        <div style="height: 340px;" echarts [options]="requestedVsDispatchedOption" class="demo-chart" *ngIf="!fulfilled_shipments_graph.loader"></div>
                        </div>
                        <div class="error-message" *ngIf="fulfilled_shipments_graph.error_message">
                        <h3>{{'OVERVIEW_DASHBOARD.fulfilled_shipment_status' | translate}}</h3>
                        <span >
                            {{fulfilled_shipments_graph.error_message}}
                        </span>
                        </div>
                    </div>
                    <div class="g-card" style="width: 99%;margin-top: 10px; height: auto;">
                      <div class="content" *ngIf="!delivery_point_data.error_message">
                        <mat-spinner style="margin-left: auto;margin-right: auto; margin-top: 150px;"  *ngIf="delivery_point_data.loader" [diameter]="25"></mat-spinner>
                        <div style="height: 280px;" echarts [options]="deliveryPointsOption" class="demo-chart" *ngIf="!delivery_point_data.loader"></div>
                      </div>
                      <div class="error-message" *ngIf="delivery_point_data.error_message">
                        <h3>{{'OVERVIEW_DASHBOARD.delivery_points_status' | translate}}</h3>
                        <span >
                          {{delivery_point_data.error_message}}
                        </span>
                      </div>
                    </div>
                </div>
              </div>

              <div class="opsStatus"  *ngIf="view.id == 'opsStatus' && view.show" @fadeIn>
                <div class="label">
                  {{'OVERVIEW_DASHBOARD.overall_metrics' | translate}}
                  <div class="minimize">
                    <mat-icon aria-hidden="false" (click)="resetOverallMetrics();getOverallMetrics()">refresh</mat-icon>
                  </div>
                </div>
                <div class="row">
                  <!-- <div class="column"> -->
                    <!-- <div class="card">
                        <div class="label">
                            {{'OVERVIEW_DASHBOARD.revenues_ytd' | translate}}
                        </div>
                        <div class="content" *ngIf="!revenue_data.error_message">
                          <mat-spinner style="margin-left: auto;margin-right: auto; margin-top: 135px;"  *ngIf="revenue_data.loader" [diameter]="25"></mat-spinner>
                          <div class="revenue-value">
                            {{ currencySymbol }} {{ revenue_data.value |numberFormat: revenue_data.value}}
                          </div>
                        </div>
                        <div class="error-message" *ngIf="revenue_data.error_message">
                          <h3>{{'OVERVIEW_DASHBOARD.revenues_ytd' | translate}}</h3>
                          <span >
                            {{ revenue_data.error_message }}
                          </span>
                        </div>
                      </div> -->
                      <div class="f-card" (click)="openPostShipmentModal(0, '');">
                        <div class="label">
                            {{'OVERVIEW_DASHBOARD.fleet_utilization' | translate}}
                        </div>
                        <div class="content" *ngIf="!fleet_utilization_data.error_message">
                            <mat-spinner *ngIf="fleet_utilization_data.loader" [diameter]="20" style="margin-left: auto;margin-right: auto; margin-top: 50px;"></mat-spinner>
                            <div class="fleet-details" *ngIf="!fleet_utilization_data.loader">
                                <div class="header">
                                    <div class="title">
                                        {{'OVERVIEW_DASHBOARD.total_vehicles' | translate}}
                                    </div>
                                    <div class="title" >
                                        {{'OVERVIEW_DASHBOARD.free_vehicles' | translate}}
                                    </div>
                                    <div class="title" >
                                        {{'OVERVIEW_DASHBOARD.on_shipment' | translate}}
                                    </div>
                                </div>
                                <div class="values">
                                    <div class="value" style="color: #3a3a3a;">
                                        {{ fleet_utilization_data.total_vehicles}}
                                    </div>
                                    <div class="value" style="color: #3a3a3a">
                                        {{ fleet_utilization_data.free_vehicles }}
                                    </div>
                                    <div class="value" style="color: #3a3a3a">
                                        {{ fleet_utilization_data.on_shipment }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="error-message" *ngIf="fleet_utilization_data.error_message">
                            <h3>{{'OVERVIEW_DASHBOARD.fleet_utilization' | translate}}</h3>
                            <span >
                            {{ fleet_utilization_data.error_message }}
                            </span>
                        </div>
                        </div>
                      <div class="g-card">
                        <div class="content" *ngIf="!operation_status_data.error_message">
                          <mat-spinner style="margin-left: auto;margin-right: auto; margin-top: 135px;"  *ngIf="operation_status_data.loader" [diameter]="25"></mat-spinner>
                          <div echarts [options]="operationStatusOption" class="demo-chart" *ngIf="!operation_status_data.loader"></div>
                        </div>
                        <div class="error-message" *ngIf="operation_status_data.error_message">
                          <h3>{{'OVERVIEW_DASHBOARD.operation_status' | translate}}</h3>
                          <span >
                            {{ operation_status_data.error_message }}
                          </span>
                        </div>
                      </div>
                      <div class="t-card">
                        <mat-spinner style="margin-left: auto;margin-right: auto; margin-top: 135px;"  *ngIf="top_shippers.loader" [diameter]="25"></mat-spinner>
                        <div *ngIf="!top_shippers.loader && !top_shippers.error_message">
                          <div class="label">
                            {{'OVERVIEW_DASHBOARD.top_shippers' | translate}}
                          </div>
                          <div class="sub-label">{{'OVERVIEW_DASHBOARD.last' | translate}} {{ stats_settings.top_shippers.count }} {{stats_settings.top_shippers.type}} </div>
                          <div class="content">
                            <div class="total_vehicles">
                              {{'OVERVIEW_DASHBOARD.total_vehicles_served' | translate}}: <span style="font-size: 14px;">{{top_shippers.total_vehicles}}</span>
                            </div>
                            <div>
                              <mat-list>
                                <mat-list-item *ngFor="let shipper of top_shippers.shippers;let i = index">
                                  <div class="carrier">
                                    <div class="name">{{shipper.name}}</div>
                                    <div class="vehicles">{{shipper.no_of_shipments}}</div>
                                  </div>
                                </mat-list-item>
                              </mat-list>
                            </div>
                          </div>
                        </div>
                        <div class="error-message" *ngIf="top_shippers.error_message">
                          <h4>{{'OVERVIEW_DASHBOARD.top_shippers' | translate}}</h4>
                          <span >
                            {{ top_shippers.error_message }}
                          </span>
                        </div>
                      </div>
                  <!-- </div> -->

                  <div class="loading_off_loading_time">
                    <mat-spinner style="margin-left: auto;margin-right: auto; margin-top: 205px;"  *ngIf="loading_off_loading_time_data.loader" [diameter]="25"></mat-spinner>
                    <div *ngIf="!loading_off_loading_time_data.loader && !loading_off_loading_time_data.error_message">
                      <div class="label">
                        {{'OVERVIEW_DASHBOARD.loading_off_loading_time' | translate}}
                      </div>
                      <div class="content">
                        <div class="table">
                          <table mat-table *ngIf="loading_off_loading_time_data.data.length;else noLocations" [dataSource]="loading_off_loading_time_data.data">
                            <ng-container matColumnDef="locations">
                              <th mat-header-cell *matHeaderCellDef class="customHeader">
                                <span>
                                  {{'OVERVIEW_DASHBOARD.locations' | translate}}
                                </span>
                              </th>
                              <td mat-cell *matCellDef="let element; let i = index">
                               <div style="padding:5px 0px">
                                {{element.name}}
                               </div>
                               <div style="color: gray;">
                                {{element.area}}
                               </div>
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="truck_type">
                              <th mat-header-cell *matHeaderCellDef class="customHeader">
                                  <span>
                                    {{'OVERVIEW_DASHBOARD.truck_type' | translate}}
                                  </span>
                              </th>
                              <td mat-cell *matCellDef="let element" style="text-align: center;">
                                <span >
                                  {{element.truck_type.name}}
                                </span>
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="material">
                                <th mat-header-cell *matHeaderCellDef class="customHeader">
                                    <span>
                                      {{'OVERVIEW_DASHBOARD.material' | translate}}
                                    </span>
                                </th>
                                <td mat-cell *matCellDef="let element" style="text-align: center;">
                                  <span >
                                    {{element.material.name}}
                                  </span>
                                </td>
                              </ng-container>
                              <ng-container matColumnDef="loading_time">
                                <th mat-header-cell *matHeaderCellDef class="customHeader">
                                    <span>
                                      {{'OVERVIEW_DASHBOARD.loading_time' | translate}}
                                    </span>
                                </th>
                                <td mat-cell *matCellDef="let element" style="text-align: center;">
                                  <span >
                                    {{element.average_loading_time}}
                                  </span>
                                </td>
                              </ng-container>
                              <ng-container matColumnDef="unloading_time">
                                <th mat-header-cell *matHeaderCellDef class="customHeader">
                                    <span>
                                      {{'OVERVIEW_DASHBOARD.unloading_time' | translate}}
                                    </span>
                                </th>
                                <td mat-cell *matCellDef="let element" style="text-align: center;">
                                  <span >
                                    {{element.average_unloading_time}}
                                  </span>
                                </td>
                              </ng-container>
                            <tr mat-header-row *matHeaderRowDef="loading_off_loading_time_columns;sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: loading_off_loading_time_columns;"></tr>
                          </table>
                        </div>
                        <ng-template #noLocations>
                          <div class="noLocations">
                            {{'OVERVIEW_DASHBOARD.no_info' | translate}}
                          </div>
                        </ng-template>
                      </div>
                    </div>
                    <div class="error-message" *ngIf="loading_off_loading_time_data.error_message">
                      <h3>{{'OVERVIEW_DASHBOARD.loading_off_loading_time' | translate}}</h3>
                      <span>
                        {{ loading_off_loading_time_data.error_message }}
                      </span>
                    </div>
                  </div>
                  <div class="loading_off_loading_time">
                    <mat-spinner style="margin-left: auto;margin-right: auto; margin-top: 205px;"  *ngIf="loading_off_loading_time_data.loader" [diameter]="25"></mat-spinner>
                    <div *ngIf="!loading_off_loading_time_data.loader && !loading_off_loading_time_data.error_message">
                      <div class="label">
                        {{'OVERVIEW_DASHBOARD.shipmentsPending' | translate}}
                      </div>
                      <div class="content">
                        <div class="table">
                         <table mat-table *ngIf="postTransitShipmentCount.length" class="overview_table" [dataSource]="postTransitShipmentCount">
                <ng-container matColumnDef="value">
                  <th mat-header-cell *matHeaderCellDef class="customHeader" style="text-align: left;">
                    <span>
                      {{'OVERVIEW_DASHBOARD.noOfShipments' | translate}}
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index" style="text-align: left;width: 200px;">
                    <div style="font-size: 13px;line-height: 1.7;">
                      {{element.value}}
                    </div>

                  </td>
                </ng-container>
                <ng-container matColumnDef="day">
                  <th mat-header-cell *matHeaderCellDef class="customHeader" style="text-align: center;">
                    <span>
                      {{'OVERVIEW_DASHBOARD.day' | translate}}
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let element" style="text-align: center;width: 200px;">
                    <span>
                      {{element.name}}
                    </span>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="dueColumns;sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: dueColumns;" (click)="openShipmentDashboard($event, 'due', row)"></tr>
              </table>
                        </div>
                        <ng-template #noLocations>
                          <div class="noLocations">
                            {{'OVERVIEW_DASHBOARD.no_info' | translate}}
                          </div>
                        </ng-template>
                      </div>
                    </div>
                    <div class="error-message" *ngIf="loading_off_loading_time_data.error_message">
                      <h3>{{'OVERVIEW_DASHBOARD.loading_off_loading_time' | translate}}</h3>
                      <span>
                        {{ loading_off_loading_time_data.error_message }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
        </div>
    </div>
  </div>
</div>

<div class="vehicle-planning-tool" *ngIf="selectedTab === 'Planning Tool'">
   <div class="vehicle-planning-head">
    <div class="planning-header">
      <h2>{{"OVERVIEW_DASHBOARD.planningToolTitle" | translate}}</h2>
    </div>
    <div class="vehicle-search-wrapper">
     <div class="vehicle-search-bar">
       <input placeholder="Search by Vehicle No" [(ngModel)]="searchVehicle" (keyup.enter)="searchVehicle && filterVehicleNo()"/>
       <img src="assets/search_icon_new.svg" (click)="filterVehicleNo()" >
     </div>
     </div>
     <div class="refresh-icon" style="cursor: pointer;" (click)="refreshMVTowardsPlant()">
       <img src="assets/refresh_new.svg"/>
     </div>
   </div>
 
  <div class="planning-filters">
    <div class="custom-select">
      <div class="select-input" (click)="toggleDropdown()">
        <div class="selected-options">
          <span *ngIf="isStatesSelected">{{ selectedStateNamesString }}</span>
          <span *ngIf="!isStatesSelected">Select State</span>
        </div>
        <span class="arrow" [class.open]="dropdownOpen"><img src="assets/down-arrow.svg" height="24px" width="24px"/></span> <!-- Unicode for down arrow -->
      </div>
      <div class="select-dropdown" *ngIf="dropdownOpen">
        <div class="select-header">
          <input type="text" [(ngModel)]="searchTerm" (input)="filterOptions()" placeholder="search" class="search-bar" />
        </div>
        <div class="select-options">
          <div class="option" *ngFor="let option of filteredOptions">
            <label>
              <input type="checkbox" [(ngModel)]="option.checked" value="option" (ngModelChange)="updateStateName()" style="cursor: pointer;"/>
              {{ option.name }}
            </label>
          </div>
        </div>
        <div class="dropdown-footer">
          <button class="btn clear-btn" (click)="clearSelection()">Clear</button>
          <button class="btn apply-btn" (click)="applySelection()">Submit</button>
        </div>
      </div>
    </div>

    <div class="overlay" *ngIf="dropdownOpen" (click)="closeDropdown()"></div>
    
  </div>
  <div class="planning-table">
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortMVTowardsPlant($event)">
      <ng-container matColumnDef="SINo">
        <th mat-header-cell sticky *matHeaderCellDef> SI No. </th>
        <td mat-cell *matCellDef="let element; let i = index;">
          <div style="border-radius: 6px;">
            {{ i + 1}} 
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="vehicleNo">
        <th mat-header-cell sticky *matHeaderCellDef mat-sort-header> Vehicle No. </th>
        <!-- (mouseleave)="element.openPopup = false" -->
        <td mat-cell *matCellDef="let element" (mouseenter)="initChart(element.vehicleNo);element.openPopup = true;" (mouseleave)="element.openPopup = false"><div style="cursor: pointer;">{{element.vehicleNo}}</div>
        <div class="vehicle-number-chart" *ngIf="element.openPopup" style="border-radius: 6px;">
          <div class="header">
            Vehicle No.<span class="vehicle-no">{{element.vehicleNo}}</span>
          </div>
          <div class="chart-content-wrapper"> 
            <div echarts [options]="vehicleChartOptions" class="chart-container"></div>    
            <div class="chart-info">
              <div class="percentage">{{ availableVehiclesTrip }}</div>
              <span class="percentage-label">Available %</span>
            </div>
            <div class="chart-right-wrapper">
              <span class="previous-trips-wrapper">
                {{ totalTripChart > 1 ? 'Vehicle Availability (Last ' + totalTripChart + ' Trips)' : 'Vehicle Availability (Last Trip)' }}
              </span>
              <div  class="previous-trips">
                <div *ngFor="let item of previousTripsChart" 
                >
                <div>
                 <span style="display: flex;column-gap: 8px;">
                  <div [ngClass]="{'green-dot' : item.available, 'red-dot': !item.available}"></div>
                  {{item.date}}</span>
                </div>
              </div>
              </div>
            </div>
            <div class="popup-right-info">
              <div class="popup-box">
                <div class="popup-info-row">
                  <div class="role">
                    Driver Name
                  </div>
                  <div class="name">
                   {{vehicleContactDetails.driver_name || 'N/A'}}
                  </div>
                  <div class="number">
                    <img src="assets/contact_icon.svg" /> {{vehicleContactDetails.driver_mobile || '--------'}}
                  </div>
                </div>
                <div class="popup-info-row">
                  <div class="role">
                    Owner Name
                  </div>
                  <div class="name">
                    {{vehicleContactDetails.owner_name || 'N/A'}}
                  </div>
                  <div class="number">
                    <img src="assets/contact_icon.svg" />{{vehicleContactDetails.owner_mobile || '--------'}}
                  </div>
                </div>
                <div class="popup-info-row">
                  <div class="role">
                    Broker Name
                  </div>
                  <div class="name">
                   {{vehicleContactDetails.broker_name || 'N/A'}}
                  </div>
                  <div class="number">
                    <img src="assets/contact_icon.svg" />{{vehicleContactDetails.broker_mobile || '--------'}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>  
        </td>
      </ng-container>
    
      <ng-container matColumnDef="state">
        <th mat-header-cell sticky *matHeaderCellDef mat-sort-header> State </th>
        <td mat-cell *matCellDef="let element" style="width: 220px;"> 
          <div style="border-radius: 6px;">
            {{element.state}} 
          </div> 
        </td>
          </ng-container>
    
      <ng-container matColumnDef="available">
        <th mat-header-cell sticky *matHeaderCellDef> Available in 1 or 2 Days </th>
        <td mat-cell *matCellDef="let element" style="width: 300px;"> 
          <div style="border-radius: 6px;">
            {{element.available}}
          </div> 
        </td>
      </ng-container>

      <ng-container matColumnDef="expectedDate">
        <th  mat-header-cell sticky *matHeaderCellDef mat-sort-header> Expected Date </th>
        <td mat-cell *matCellDef="let element" style="width: 250px;">
          <div style="border-radius: 6px;">
            <div *ngIf="!element.isEdit">
              {{element.expectedDate !== 'NA' ? (element.expectedDate | date:'dd MMM yyyy') : element.expectedDate}}
            </div>
            <div *ngIf="element.isEdit">
              <div class="input" style="width: 200px;">
                <input type="text" class="inputField"
                  placeholder="Date" [(ngModel)]="element.expectedDate" (click)="fromDateInput.open()"
                  [matDatepicker]="fromDateInput" />
                <mat-datepicker #fromDateInput></mat-datepicker>
                <span class="material-icons dateIcon"> date_range </span>
              </div>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="remarks">
        <th mat-header-cell sticky *matHeaderCellDef mat-sort-header> Remarks </th>
        <td mat-cell *matCellDef="let element" style="width: 200px;"> 
          <div style="border-radius: 6px;">
            <div *ngIf="!element.isEdit">
              <span>{{element.remarks}}</span> <br>
              <span style="font-size: 10px; color: #71747A;">{{element.remarksDate}}</span>
            </div>
            <div *ngIf="element.isEdit">
              <div class="custom-select">
                <div class="select-input" (click)="element.dropdownOpen = !element.dropdownOpen">
                  <div class="selected-options">
                    <span *ngIf="isRemarkSelected || element.remarks !== 'NA'">{{ element.remarks }}</span>
                    <span *ngIf="!isRemarkSelected && element.remarks === 'NA' ">Select Remark</span>
                  </div>
                  <span class="arrow" [class.open]="element.dropdownOpen"><img src="assets/down-arrow.svg" height="24px" width="24px"/></span> <!-- Unicode for down arrow -->
                </div>
                <div class="select-dropdown" *ngIf="element.dropdownOpen">
                  <div class="select-options">
                    <div class="option" *ngFor="let remark of remarks" (click)="handleSelectRemark(element, remark); element.dropdownOpen = false">
                      <label>
                        {{ remark }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="overlay" *ngIf="element.dropdownOpen" (click)="element.dropdownOpen = false"></div>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell sticky *matHeaderCellDef> Action </th>
        <td mat-cell *matCellDef="let element" style="width: 100px;">
          <div style="border-radius: 6px;">
            <div class="actions-cont" *ngIf="!element.isEdit">
              <div class="action-btn" (click)="element.openActionMenu = !element.openActionMenu;">
               <div class="content"><div class="dot"></div><div class="dot"></div><div class="dot"></div></div>
              </div>
              <div class="actions-dropdown" *ngIf="element.openActionMenu">
              <div class="action-item" (click)="element.isEdit = !element.isEdit;element.openActionsMenu=!element.openActionsMenu">
                <img src="assets/edit_icon.svg" height="16px" width="16px" style="margin-left: 12px;"/><span>Edit</span>
              </div>
              </div>
            </div>
            <div *ngIf="element.isEdit">
            <button class="edit-btn" (click)="saveChangesData(element); element.isEdit = !element.isEdit;">Save Changes</button>
            </div>
          </div>
          <div class="overlay" *ngIf="element.openActionMenu" (click)="element.openActionMenu = false"></div>
        </td>
      </ng-container>
    
      <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true" ></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    
    
  </div>
</div>

<ng-template #reorderRows>
  <div class="reorderMain">
    <div class="header">
      Reorder Data Rows
      <mat-icon class="saveBtn" (click)="dashboardLayoutDialog.close()">save</mat-icon>
    </div>
    <div class="subheader">
      Drag and drop to customize the dashboard layout
    </div>
    <div class="content" cdkDropList (cdkDropListDropped)="drop($event)">
      <div class="formElement" style="margin-bottom: 6px; margin-top: 10px; "
            *ngFor="let view of views;let last = last; let index = index; let first = first;" cdkDrag>
            <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
            <div class="rowName">
              <div class="dragLoca grabbable">
                <i class="material-icons">
                  drag_indicator
                </i>
              </div>
              {{view.name}}
            </div>
      </div>
    </div>
  </div>
</ng-template>